export enum DialogType {
  Availability,
  CancelBooking,
  Checkout,
  ConfirmTrip,
  DayMap,
  Editor,
  GooglePlacesImport,
  NewExperience,
}
